import { motion } from 'framer-motion';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { PasswordAuthForm } from '@/components/auth/PasswordAuthForm';
import { SessionGuard } from '@/lib/sessionGuard';
import { AnimatedBackground } from '@/components/AnimatedBackground';

const Auth = () => {
  return (
    <SessionGuard requireAuth={false}>
      <div className="relative min-h-screen flex items-center justify-center bg-gradient-to-br from-background via-card to-background p-4 overflow-hidden">
        <AnimatedBackground opacity={0.15} />
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <Card className="w-full max-w-md border-border/50 shadow-lg">
            <CardHeader className="space-y-1">
              <motion.div
                initial={{ scale: 0 }}
                animate={{ scale: 1 }}
                transition={{ type: 'spring', duration: 0.5 }}
                className="flex items-center justify-center mb-4"
              >
                <img 
                  src="/logo/debtnet-static.png" 
                  alt="DebtNet logo" 
                  className="h-20 w-auto"
                />
              </motion.div>
              <CardDescription className="text-center">
                Access your DebtNet account
              </CardDescription>
            </CardHeader>
            <CardContent>
              <PasswordAuthForm />
            </CardContent>
          </Card>
        </motion.div>
      </div>
    </SessionGuard>
  );
};

export default Auth;
